import React, { useState } from "react";
import "./SliderWithTicks.css"; // Ensure this CSS file is created and linked

interface SliderProps {
  min: number;
  max: number;
  value: number;
  onChange: (value: number) => void;
}

const Slider: React.FC<SliderProps> = ({ min, max, value, onChange }) => {
  const [sliderValue, setSliderValue] = useState(value);

  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value);
    setSliderValue(newValue);
    onChange(newValue);
  };

  const tickMarks = Array.from({ length: max - min + 1 }, (_, index) => min + index);

  return (
    <div className="spec-slider">
      <input
        type="range"
        min={min}
        max={max}
        value={sliderValue}
        onChange={handleSliderChange}
        className="slider"
      />
      <div className="tick-marks">
        {tickMarks.map((tick, index) => (
          <div key={tick} className="tick_pos" style={{ left: `${(index / (tickMarks.length - 1)) * 100}%` }}>
            <div className="tick-mark"></div>
            <span className="tick-label">{tick}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Slider;
